<template>
  <div>
    <span
      class="subtitle-2 font-weight-bold grey--text text--darken-1 mb-3"
    >
      {{ label }}
    </span>
    <div class="d-flex align-center">
      <progress-breakdown
        class="mr-2 flex-grow-1"
        :progress-items="progressItems"
      />
      <strong
        class="caption font-weight-bold grey--text text--darken-3"
      >
        {{ progressTotal }} / {{ totalCount }}
      </strong>
    </div>
  </div>
</template>

<script>
import ProgressBreakdown from '@/components/Common/ProgressBreakdown';

export default {
  name: 'ResolutionProgress',
  components: { ProgressBreakdown },
  props: {
    label: {
      type: String,
      default: 'Conflict Resolution',
    },
    relevantCount: {
      type: Number,
      default: 0,
    },
    notRelevantCount: {
      type: Number,
      default: 0,
    },
    notSureCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    progressTotal() {
      return (
        this.relevantCount + this.notRelevantCount + this.notSureCount
      );
    },
    progressItems() {
      return [
        {
          color: 'success',
          count: this.relevantCount,
        },
        {
          color: 'warning',
          count: this.notSureCount,
        },
        {
          color: 'error',
          count: this.notRelevantCount,
        },
        {
          color: 'grey lighten-2',
          count: this.totalCount - this.progressTotal,
        },
      ];
    },
  },
};
</script>
